<template>
    <div >
        <PullRefresh v-model="isReFresh" @refresh="onRefresh">
            <List
                    style="height: 100%;padding: 5px;background:#eee;"
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    loading-text="拼命加载中..."
                    @load="onLoad"
                    :offset="50"
                    :immediate-check="true"
            >
                <TaskDeviceInfo v-for="item in taskDevices" :key="item.id" :taskDevice="item"  @onRefresh="onRefresh"/>
            </List>
        </PullRefresh>
        <Button type="info" block class="fixed-bottom-button" @click="updateDevice">新增加装设备</Button>
        <TaskDevicePopup :show="show" type="devicePopup" @panel="switchPanel" @onRefresh="onRefresh"/>
    </div>
</template>

<script>
    import {PullRefresh, List, Button} from "vant"
    import TaskDeviceInfo from "./TaskDeviceInfo"
    import TaskDevicePopup from "../components/TaskDevicePopup"


    export default {
        components: {
            TaskDevicePopup,
            List,
            PullRefresh,
            TaskDeviceInfo,
            Button
        },
        props: {},
        data() {
            return {
                taskId: this.$route.params.id,
                taskDevices: [],
                isReFresh: false,
                loading: false,
                show: false,
                finished: false
            }
        },
        computed: {},
        created() {
        },
        mounted() {
        },
        methods: {
            switchPanel(type, data) {
                switch (type) {
                    case "devicePopup":
                        this.show = !this.show;
                        break;
                    default:
                        break;
                }
            },
            updateDevice() {
                this.show = true;
            },
            onRefresh() {
                this.isReFresh = true;
                this.taskDevices = [];
                this.onLoad(true);
            },
            onLoad(isPullRefresh) {
                this.$http.tokiot.prospect.taskDevice.list({
                    taskId: this.taskId,
                    size: 20,
                    // page:this.taskItems.length / 20 + 1
                })
                    .then(res => {
                        if (res) {
                            this.taskDevices.push(...res.rows);
                            this.loading = false;
                            if (isPullRefresh) this.isReFresh = false;
                            if (this.taskDevices.length >= res.total) {
                                this.finished = true;
                            }
                        }
                    })
            },
        },
        watch: {}
    }

</script>

<style scoped>
    .fixed-bottom-button {
        position: fixed;
        bottom: 8px;
        width: calc(100% - 16px);
    }


</style>